import { useMemo } from 'react';
import OrderState from '~/constants/common/OrderState';
import { useUserPurchasing } from '~/context/vdp/UserVehicleContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useCtaButtonState from './useCtaButtonState';
import useHasCorePurchaseAndIsViewingReservable from './useHasCorePurchaseAndIsViewingReservable';

export default function useConfirmModalCases(onlyConfirmCancellation: boolean) {
  const purchasing = useUserPurchasing();
  const hasCorePurchaseAndIsViewingReservable =
    useHasCorePurchaseAndIsViewingReservable();
  const { fuelDescription, transmission } = useGetVehicleDetails();
  const { continuePurchase } = useCtaButtonState();

  const hasPreOrder = purchasing?.orderState === OrderState.Reserved;
  const isManual = transmission?.toLowerCase().includes('manual') ?? false;
  const isDiesel = fuelDescription?.toLowerCase().includes('diesel') ?? false;

  return {
    hasCorePurchaseAndIsViewingReservable,
    hasPreOrder,
    isManual: isManual && !continuePurchase && !onlyConfirmCancellation,
    isDiesel: isDiesel && !continuePurchase && !onlyConfirmCancellation
  };
}

export function useShouldShowConfirmationModal() {
  const confirmModalCases = useConfirmModalCases(false);

  return useMemo(
    () => Object.values(confirmModalCases).some(Boolean),
    [confirmModalCases]
  );
}
